module.exports = __webpack_public_path__ + "img/free.3536d150.png";